import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Box, Button, Typography, Avatar, Paper } from "@mui/material";
import { useRecoilState } from "recoil";
import { platformState, userInfoState } from "../global-state";
import { Auth } from "aws-amplify";
import { useAuth } from "./auth-provider";
import { USER_AUTH_CONFIG } from "../aws-config";
import { Amplify } from "aws-amplify";
import { checkExternalLogin, saveAuthRelay } from "./user-login-service";
import useApiCall from "../common/api-call";
import { useToast } from "../common/toast";

const DesktopLogin = () => {
  const [email, setEmail] = useState(null);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const location = useLocation();
  const [platform] = useRecoilState(platformState);
  const [userInfo, setUserInfo] = useRecoilState(userInfoState);
  const { checkAuthState } = useAuth();
  const { apiCall } = useApiCall();
  const { errorToast } = useToast();
  const params = new URLSearchParams(location.search);
  const code = params.get("id");

  useEffect(() => {
    if (!loading) {
      return;
    }
    const verifyAuth = async () => {
      try {
        Amplify.configure(USER_AUTH_CONFIG);
        await Auth.currentSession();
      } catch (error) {
        console.error("Error checking auth state:", error);
        history.push(`/user-login?source=desktop&id=${code}`);
      }
      // await checkAuthState();
      setLoading(false);
    };

    verifyAuth();
  }, [history, checkAuthState]);

  useEffect(() => {
    setEmail(userInfo?.name);
  }, [userInfo]);

  const handleAuthorize = async () => {
    Amplify.configure(USER_AUTH_CONFIG);
    const user = await Auth.currentAuthenticatedUser();
    const idToken = user.signInUserSession.idToken.jwtToken;
    const refreshToken = user.signInUserSession.refreshToken.token;
    const accessToken = user.signInUserSession.accessToken.jwtToken;
    const expirationTime = user.signInUserSession.idToken.payload.exp * 1000;

    if (!code) {
      console.error("No code found in URL");
      errorToast("No code found in URL");
      return;
    }
    const authState = {
      id: code,
      idToken,
      refreshToken,
      accessToken,
      expirationTime,
    };
    console.log("userData", authState);

    await saveAuthRelay(apiCall, authState);
    history.replace("/desktop-auth-done");
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      ></Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Paper
        sx={{
          p: 4,
          maxWidth: 400,
          width: "100%",
          bgcolor: "background.paper",
          boxShadow: "none",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src="/logo192.png"
            alt="Company Logo"
            sx={{
              maxWidth: "64px",
              width: "100%",
              height: "auto",
              display: "block",
              margin: "0 auto",
              mb: 2,
            }}
          />
          <>
            {email && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  mb: 3,
                }}
              >
                <Typography variant="h6">
                  mHome desktop client tries to login with user{" "}
                  <Box component="span" sx={{ fontWeight: "bold" }}>
                    {email}
                  </Box>
                </Typography>
              </Box>
            )}
            <Button
              variant="contained"
              onClick={handleAuthorize}
              fullWidth
              sx={{
                borderRadius: "50px",
                textTransform: "none",
              }}
            >
              Authorize
            </Button>
          </>
        </Box>
      </Paper>
    </Box>
  );
};

export default DesktopLogin;
